import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageProvider";
import type { FitnessStatus } from "@/hooks/useFitnessResource";

export default function FitnessDataState({ status, busy = false, onRetry }: { status: FitnessStatus; busy?: boolean; onRetry: () => void }) {
  const { t } = useLanguage();
  const navigate = useNavigate();
  if (status === "ready") return null;
  return <div className="my-4 rounded-2xl border border-border bg-card p-4" aria-busy={busy}>
    <p role={status === "error" ? "alert" : "status"} className="text-sm leading-relaxed text-muted-foreground">
      {t(status === "loading" ? "ux.loading" : status === "signed-out" ? "fitness.ux.signInRequired" : "fitness.ux.loadError")}
    </p>
    {status !== "loading" && <button type="button" disabled={busy} onClick={() => status === "signed-out" ? navigate("/auth?mode=signin") : onRetry()}
      className="mt-2 min-h-11 rounded-xl px-3 font-medium text-primary underline focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-50">
      {t(status === "signed-out" ? "auth.signIn" : "common.retry")}
    </button>}
  </div>;
}
